/* eslint-disable @wyz/module/invalid-import */
import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import AppLayout from '~/common/app-layout';
import { ErrorBoundary } from '~/common/components';
import {
  ApiProvider,
  ApplicationProvider,
  DebugProvider,
  PluginProvider,
} from '~/common/context';

import PostSignIn from '~/common/pages/post-signin';

const WyzConnectRouter = React.lazy(() => import('./connect/router'));
const PurchaseRouter = React.lazy(
  () => import('./purchase/router/purchase-router'),
);
const CallCenterRouter = React.lazy(
  () => import('./purchase/router/call-center-router'),
);
const QuoteRouter = React.lazy(() => import('./purchase/router/quote-router'));
const SupplierContainerOrderRouter = React.lazy(
  () => import('./container-order/router/supplier-container-order-router'),
);
const PricingPoliciesRouter = React.lazy(
  () => import('./purchase/router/pricing-policies-router'),
);

const AuthenticatedApp = () => (
  <DebugProvider>
    <ApiProvider>
      <ApplicationProvider>
        <PluginProvider>
          <ErrorBoundary>
            <AppLayout>
              <React.Suspense fallback={null}>
                <Routes>
                  <Route path='/post-signin' element={<PostSignIn />} />

                  <Route
                    path='/call-center/*'
                    element={<CallCenterRouter />}
                  ></Route>
                  <Route
                    path='/purchase/*'
                    element={<PurchaseRouter />}
                  ></Route>
                  <Route path='/quotes/*' element={<QuoteRouter />}></Route>
                  <Route
                    path='/containers/suppliers/*'
                    element={<SupplierContainerOrderRouter />}
                  ></Route>
                  <Route
                    path='/pricing-policies/*'
                    element={<PricingPoliciesRouter />}
                  ></Route>
                  {/* redirect to / for /register or /onboarding */}
                  <Route path='/onboarding' element={<Navigate to='/' />} />
                  <Route path='/register' element={<Navigate to='/' />} />
                  <Route path='/login' element={<Navigate to='/' />} />

                  {/* fallback */}
                  <Route path='*' element={<WyzConnectRouter />} />
                </Routes>
              </React.Suspense>
            </AppLayout>
          </ErrorBoundary>
        </PluginProvider>
      </ApplicationProvider>
    </ApiProvider>
  </DebugProvider>
);

export default AuthenticatedApp;
